import Hero from "../components/sections/Hero";
import About from "../components/sections/About";
import Sponsor from "../components/sections/Sponsor";
import CorsiRievocazione from "../components/CorsiRievocazione";
import Corsi from "../components/corsi/Corsi";
import Istruttori from "../components/sections/Istruttori";
import Medagliere from "../components/sections/Medagliere";
import Ricostruzione from "../components/sections/Ricostruzione";
import ContattiFAQ from "../components/sections/ContattiFAQ";

function Home() {
  return (
    <div>
      <Hero />
      {/* <CorsiRievocazione /> */}
      <Corsi />
      <Medagliere />
      <Ricostruzione />
      <Istruttori />
      <About />
      <ContattiFAQ />
      <Sponsor />
    </div>
  );
}

export default Home;
